import {getRelevantLocations} from './buildCreateOrderPayload'
import {shouldRequireOnboardingCall} from './shouldRequireOnboardingCall'

// Which of this order's locations individually need an onboarding call —
// per the user's explicit call: for Multi-location Parent Pay, scheduling is
// decided PER LOCATION (does *this* location's cart need a kickoff call?),
// not once for the combined cart. Single location / Self Pay naturally
// reduces to a one-location array here, matching today's behavior.
// isTgpUpgradeEnabled: GEP-7133 / FULSAS-13599 — forwarded to
// shouldRequireOnboardingCall for every location. Defaults to false, so
// omitting it reproduces the pre-GEP-7133 behavior exactly.
export function getSchedulingLocations({
  locations,
  orderMode,
  selectedLocationId,
  roles = [],
  isTgpUpgradeEnabled = false,
}) {
  const relevantLocations = getRelevantLocations({
    locations,
    orderMode,
    selectedLocationId,
  })
  return relevantLocations.filter(loc =>
    shouldRequireOnboardingCall(loc.items ?? [], {
      roles,
      isTgpUpgradeEnabled,
    }),
  )
}
